import { useGetDailyNavSetupStatus } from 'services/hooks/dailyNav';

export const useDailyNavSetupProgress = (firmId?: number | null) => {
  const { data, isLoading } = useGetDailyNavSetupStatus(firmId);
  const hasFirmConfig = Boolean(data?.has_firm_config);
  const pendingCount = data?.pending_company_count ?? 0;
  return {
    isLoading: isLoading || !data,
    hasFirmConfig,
    pendingCount,
    isComplete: hasFirmConfig && pendingCount === 0,
  };
};
